import apiClient from '@/api/apiClient'

export const getAccount = accountId =>
  apiClient.get(`api/v1/accounts/${accountId}`)

export const updateAccount = (accountId, payload) =>
  apiClient.patch(`api/v1/accounts/${accountId}`, payload)
